module.exports = "/images/vendor/flag-icon-css/flags/1x1/lt.svg?70975be09055c7db032d5a56a452d5d5";